import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { H1, Text } from '../components/ui/Typography';
import { Button } from '../components/ui/Button';
import SafeIcon from '../common/SafeIcon';
import { translations } from '../translations';

const International = () => {
  const { lang = 'nl' } = useParams();
  const navigate = useNavigate();
  
  // Dynamic translation binding
  const t = translations[lang]?.international || translations.nl.international;

  const handleStartScan = () => {
    navigate(`/${lang}/internationaal/scan`);
  };

  return (
    <div className="w-full">
      <section className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-20">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          <motion.div 
            initial={{ opacity: 0, x: -20 }} 
            animate={{ opacity: 1, x: 0 }} 
            transition={{ duration: 0.6 }} 
            className="order-2 lg:order-1"
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-navy-50 text-navy-600 text-[10px] uppercase tracking-widest font-bold mb-8">
              <SafeIcon name="Globe" /> <span>{t.badge}</span>
            </div>
            
            <H1 className="mb-6 text-gradient">{t.title}</H1>
            
            <Text className="mb-8 text-slate-600 leading-relaxed text-lg">
              {t.desc}
            </Text>

            <div className="space-y-8 mb-12">
              {t.features.map((item, i) => (
                <div key={i} className="flex gap-5 group">
                  <div className="mt-1 w-12 h-12 rounded-2xl bg-slate-50 border border-slate-100 flex flex-shrink-0 items-center justify-center text-navy-900 group-hover:bg-navy-900 group-hover:text-white transition-all duration-300">
                    <SafeIcon name={item.icon} className="text-lg" />
                  </div>
                  <div>
                    <h4 className="font-bold text-navy-900 text-lg">{item.title}</h4>
                    <p className="text-sm text-slate-500 mt-1 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <Button 
              onClick={handleStartScan} 
              className="px-10 py-5 text-base shadow-xl shadow-navy-900/10"
            >
              {t.cta}
            </Button>
          </motion.div>

          <div className="order-1 lg:order-2">
            <div className="aspect-square rounded-[3rem] bg-navy-950 border border-navy-800 flex items-center justify-center relative overflow-hidden">
              <div className="absolute inset-0 bg-blueprint-pattern opacity-20"></div>
              <SafeIcon name="Globe" className="text-[12rem] text-white/10 relative z-10" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default International;